(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"]) return;
  try {
    

    // get tallest tab__content element
    let height = -1;

    $('.tab__content').each(function() {
        height = height > $(this).outerHeight() ? height : $(this).outerHeight();
     $(this).css('position', 'absolute');
    });
  
  // set height of tabs + top offset
    $('[data-tabs]').css('min-height', height + 40 + 'px');
    

  } catch(e) { console.error(e); }
})();
})();
